// "@page" não pode ser escopado por classe/seletor: injeta a orientação paisagem só
// durante esta impressão, em vez de deixá-la fixa no CSS global (que afetaria a
// impressão de qualquer outra tela do app).
export function printLandscape() {
  const style = document.createElement('style');
  style.textContent = '@media print { @page { size: landscape; margin: 12mm; } }';
  document.head.appendChild(style);

  const cleanup = () => {
    style.remove();
    window.removeEventListener('afterprint', cleanup);
  };
  window.addEventListener('afterprint', cleanup);

  window.print();
}
